import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Link as RouterLink } from 'react-router-dom';
import { useNewestReports } from '@/features/library';
import { AssetDot } from '@/shared/components/AssetDot';
import { formatDayMonth } from '@/shared/lib/format';

/** The newest reports, each opening on its Ask tab. Hidden until they load, so the home page never jumps. */
export function NewResearch() {
  const reports = useNewestReports().data ?? [];
  if (reports.length === 0) return null;

  return (
    <Stack component="section" aria-labelledby="new-research" sx={{ gap: 1 }}>
      <Typography id="new-research" variant="caption" component="h2" sx={{ color: 'text.secondary' }}>New research you can ask about</Typography>
      <Stack direction="row" sx={{ gap: 0.75, flexWrap: 'wrap' }}>
        {reports.map((r) => (
          <ButtonBase key={r.id} component={RouterLink} to={`/documents/${r.id}?tab=ask`} sx={chipSx} aria-label={`Ask about ${r.title}, ${formatDayMonth(r.publishDate)}`}>
            <AssetDot assetClass={r.assetClass} />
            <Box component="span" sx={{ fontWeight: 500 }}>{r.title}</Box>
            <Box component="span" sx={{ color: 'text.secondary' }}>{formatDayMonth(r.publishDate)}</Box>
          </ButtonBase>
        ))}
      </Stack>
    </Stack>
  );
}

const chipSx = {
  gap: 0.75,
  height: 30,
  px: 1.25,
  borderRadius: 4,
  fontSize: '0.78125rem',
  border: 1,
  borderColor: 'divider',
  bgcolor: 'background.paper',
  transition: 'border-color 150ms, transform 150ms',
  '&:hover': { borderColor: 'surface.border', transform: 'translateY(-1px)' },
} as const;
